import { InfoCircledIcon } from '@radix-ui/react-icons'
import {
  StyledInputContainer,
  StyledLabel,
} from 'components/form/inputs/InputStyles'
import { TooltipWrapper } from 'components/TooltipWrapper'
import isNil from 'lodash/isNil'
import React, { FC } from 'react'
import styled from 'styled-components'

import {
  CoordinatesInputProps,
  CoordinatesInputTable,
} from './CoordinatesInputTable'

type CoordinateInputWithLabelProps = {
  $label?: string
  $labelColor?: string
} & CoordinatesInputProps
export const CoordinateInputWithLabel: FC<CoordinateInputWithLabelProps> = ({
  $label,
  $labelColor,
  ...coordinatesTableProps
}) => {
  const { pointAndClickApi } = coordinatesTableProps

  const hasPointAndClickControls =
    !coordinatesTableProps.isReadonly &&
    !coordinatesTableProps.disabled &&
    (pointAndClickApi.isInPointSelectionMode ||
      !isNil(pointAndClickApi.enterPointSelectionMode))

  return (
    <StyledInputContainer $labelLocation={$label ? 'side' : undefined}>
      {$label && (
        <StyledLabel $labelColor={$labelColor} htmlFor={$label}>
          {$label}
          {hasPointAndClickControls && (
            <TooltipWrapper
              side='left'
              offset={2}
              label={
                'Press "w" or "s" when using point-and-click to swap "up" or "down" between coordinates.  Holding "shift" will create a new coordinate in that direction.'
              }>
              <InfoIconWrapper>
                <InfoCircledIcon />
              </InfoIconWrapper>
            </TooltipWrapper>
          )}
        </StyledLabel>
      )}
      <CoordinatesInputTable {...coordinatesTableProps} />
    </StyledInputContainer>
  )
}

const InfoIconWrapper = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 0.25rem;
  svg {
    width: 1rem;
    height: 1rem;
    color: ${({ theme }) => theme.forecast.defaultText};
  }
`
